"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
export default function OurCommitmentToQuality() {
  const {
    ref: textRef1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  const {
    ref: textRef2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  const {
    ref: textRef3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  return <section className="relative min-h-screen bg-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-8 items-stretch">
          {}
          <div className="relative h-[500px] md:h-auto md:sticky md:top-24 md:self-start overflow-hidden rounded-lg shadow-medium" role="img" aria-label="Professional welder working on custom metal fabrication project at Romero Welding Inc">
            <div className="absolute inset-0 bg-cover bg-center bg-[url(https://romeroweldinginc.com/wp-content/uploads/2025/11/rwi10.jpg)] animate-[zoom-in_20s_ease-in-out_infinite_alternate]" />
          </div>

          {}
          <div className="flex flex-col gap-6 md:gap-8">
            <Card ref={textRef1} className={`transform transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${isVisible1 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} shadow-soft hover:shadow-medium`}>
              <CardContent className="p-6">
                <h2 className="text-3xl md:text-4xl font-display font-bold text-primary mb-4">
                  Our Commitment to Quality
                </h2>
                <p className="text-foreground leading-relaxed text-lg">
                  At Romero Welding Inc., we believe that every weld, every piece of structural steel, and every custom fabrication reflects our dedication to excellence. Located in Laguna Beach, California, we've built our reputation on delivering high-quality workmanship that stands the test of time.
                </p>
              </CardContent>
            </Card>

            <Card ref={textRef2} className={`transform transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${isVisible2 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} delay-200 shadow-soft hover:shadow-medium`} style={{
            transitionDelay: isVisible2 ? "200ms" : "0ms"
          }}>
              <CardContent className="p-6">
                <h3 className="text-2xl font-display font-semibold text-secondary-dark mb-3">
                  Precision Meets Personalization
                </h3>
                <p className="text-foreground leading-relaxed">
                  Our team combines technical expertise with a personal touch. Whether it's industrial welding, commercial projects, or structural steel work, we ensure every detail meets your specifications and exceeds industry standards. With over 20 years of experience, we understand that timely service and reliable results are what matter most to our clients.
                </p>
              </CardContent>
            </Card>

            <Card ref={textRef3} className={`transform transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${isVisible3 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} delay-[400ms] shadow-soft hover:shadow-medium`} style={{
            transitionDelay: isVisible3 ? "400ms" : "0ms"
          }}>
              <CardContent className="p-6">
                <h3 className="text-2xl font-display font-semibold text-secondary-dark mb-3">
                  Built on Trust
                </h3>
                <p className="text-foreground leading-relaxed">
                  From start to finish, we prioritize transparent communication and dependable service. Our commitment goes beyond the workshop—we build lasting relationships with every client, ensuring your project is completed with the highest level of care and professionalism.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes zoom-in {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(1.1);
          }
        }
      `}</style>
    </section>;
}